import { combineEpics } from "redux-observable";
import endOfYearFetch from "./end-of-year-fetch";

export default combineEpics(endOfYearFetch);
